// extracted by mini-css-extract-plugin
export default {"header":"PartsDetails_header__lPfu5","table":"PartsDetails_table__TtZv9"};